<div class="account-container">
  <div class="form-section" *ngIf="!isPassword">
    <div class="form" [formGroup]="updateProfileForm" >
      <div class="name">
        <!-- <p-dropdown [options]="title"></p-dropdown> -->
        <select formControlName="title" [ngClass]="{'error-border': (updateProfileForm.get('title').value == '' && submitted)}">
          <option *ngFor="let name of title" [value]="name">{{name}}</option>
        </select>
        <input type="text" [ngClass]="{'error-border': (updateProfileForm.get('firstName').value == '' && submitted)}" formControlName="firstName" class="first-name" pInputText placeholder="first name">
        <input type="text" [ngClass]="{'error-border': (updateProfileForm.get('lastName').value == '' && submitted)}" formControlName="lastName" class="last-name" pInputText placeholder="last name">
      </div>
      <div class="gender-dob">
        <select formControlName="gender" [ngClass]="{'error-border': (updateProfileForm.get('gender').value == '' && submitted)}">
          <option value="" disabled selected>gender</option>
          <option *ngFor="let gen of gender" [value]="gen.label">{{gen.name}}</option>
        </select>

        <input type="text" formControlName="dob" [ngClass]="{'error-border': (updateProfileForm.get('dob').value == '' && submitted)}" onfocus="(this.type = 'date')" placeholder="date of birth">

      </div>
      <input name="institue" formControlName="institution" [ngClass]="{'error-border': (updateProfileForm.get('institution').value == '' && submitted)}" autocomplete="off" type="text" pInputText placeholder="name of institutions">
      <input name="qualification" formControlName="qualification" [ngClass]="{'error-border': (updateProfileForm.get('qualification').value == '' && submitted)}" autocomplete="off" type="text" pInputText placeholder="qualifications">
      <textarea name="address" formControlName="address" [ngClass]="{'error-border': (updateProfileForm.get('address').value == '' && submitted)}" id="" cols="30" rows="5" placeholder="address for communication"></textarea>
      <!-- <input name="country" formControlName="country" autocomplete="off" type="text" pInputText placeholder="country"> -->
      <select class="select-div" formControlName="country" (change)="onSelectCountry()">
        <option value="" disabled selected>country</option>
        <option *ngFor="let country of countries.data"  [value]="country.name">{{country.name}}</option>
      </select>
      <div class="state-pincode">
        <select class="select-div" formControlName="state">
          <option value="" disabled selected>state</option>
          <option *ngFor="let state of states" [value]="state?.name">{{state?.name}}</option>
        </select>
        <input name="pincode" formControlName="pincode" autocomplete="off" type="text" pInputText placeholder="pincode">
      </div>
      <div class="mobile">
        <input name="code" formControlName="countryCode" class="code" pInputText autocomplete="off" type="text" placeholder="code">
        <input name="number" formControlName="phone" [ngClass]="{'error-border': (updateProfileForm.get('phone').value == '' && submitted)}" autocomplete="off" class="number" pInputText type="text" placeholder="phone number">
      </div>
      <input name="email" formControlName="email" [ngClass]="{'error-border': (updateProfileForm.get('email').value == '' && submitted)}" autocomplete="off" type="email" id="email" pInputText placeholder="e-mail">
    </div>
  </div>
  <div class="form-section" *ngIf="isPassword">
    <div class="form"  >
      <div class="label">Password reset</div>
      <input type="password" [(ngModel)]="currentPassword" placeholder="current password">
      <input type="password" [(ngModel)]="newPassword" placeholder="new password">
      <input type="password" [(ngModel)]="confirmPassword" placeholder="confirm password">
    </div>
  </div>
  <div class="img-section">
    <div class="label">Keep your info upto date!</div>
    <img src="../../../assets/images/icon 06.png" alt="">
    <button *ngIf="!isPassword" (click)="onClickPassword()">Password</button>
    <button (click)="onClickUpdate()">Update</button>
  </div>
</div>